import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { Clover, Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error('Introduce tu email');
      return;
    }

    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
      toast.success('Email enviado');
    } catch (error) {
      // Always show success to prevent email enumeration
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-12 h-12 bg-primary rounded-sm flex items-center justify-center">
            <Clover className="w-7 h-7 text-primary-foreground" strokeWidth={1.5} />
          </div>
          <div>
            <span className="font-display font-bold text-2xl tracking-tight text-foreground">TREBOL</span>
            <span className="text-sm text-muted-foreground block -mt-1">FINANCE</span>
          </div>
        </div>

        <Card className="border-border rounded-sm shadow-lg">
          <CardContent className="p-6">
            {sent ? (
              <div className="text-center space-y-4">
                <CheckCircle className="w-16 h-16 mx-auto text-emerald-500" />
                <h2 className="text-xl font-bold text-foreground">
                  Revisa tu bandeja de entrada
                </h2>
                <p className="text-muted-foreground text-sm">
                  Si existe una cuenta con ese email, recibirás instrucciones para restablecer tu contraseña.
                </p>
                <Link to="/login">
                  <Button variant="outline" className="mt-4 rounded-sm">
                    <ArrowLeft size={16} className="mr-2" />
                    Volver al inicio
                  </Button>
                </Link>
              </div>
            ) : (
              <>
                <div className="text-center mb-6">
                  <h2 className="text-xl font-bold text-foreground mb-2">
                    ¿Olvidaste tu contraseña?
                  </h2>
                  <p className="text-muted-foreground text-sm">
                    Introduce tu email y te enviaremos instrucciones
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="space-y-2">
                    <Label className="flex items-center gap-2">
                      <Mail size={16} className="text-primary" />
                      Correo Electrónico
                    </Label>
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="tu@email.com"
                      className="rounded-sm"
                      required
                    />
                  </div>

                  <Button 
                    type="submit" 
                    disabled={loading}
                    className="w-full bg-primary hover:bg-primary/90 rounded-sm"
                  >
                    {loading ? 'Enviando...' : 'Enviar instrucciones'}
                  </Button>
                </form>

                <div className="mt-6 text-center">
                  <Link to="/login" className="text-sm text-primary hover:underline flex items-center justify-center gap-1">
                    <ArrowLeft size={14} />
                    Volver al inicio de sesión
                  </Link>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
